import React from 'react';
import { Box, Link as MUILink, Typography } from '@mui/material';
import { ContentBlock } from './BlockEditor';

export function renderBlocks(blocks: ContentBlock[]) {
  return (
    <Box>
      {blocks.map((b) => {
        if (b.type === 'richtext') {
          return (
            <Box key={b.id} sx={{ mb: 1 }} dangerouslySetInnerHTML={{ __html: b.html }} />
          );
        }
        if (b.type === 'paragraph') {
          const withLinks = linkify(b.text);
          return (
            <Typography key={b.id} sx={{ whiteSpace: 'pre-wrap', mb: 1 }} variant="body2">
              {withLinks}
            </Typography>
          );
        }
        if (b.type === 'list') {
          return (
            <Box key={b.id} component="ul" sx={{ pl: 3, mb: 1 }}>
              {b.items.filter(Boolean).map((item, idx) => (
                <Box key={idx} component="li">
                  {linkifyInline(item)}
                </Box>
              ))}
            </Box>
          );
        }
        if (b.type === 'image') {
          return (
            <Box key={b.id} sx={{ my: 1 }}>
              <img src={b.url} alt={b.alt || ''} style={{ maxWidth: '100%', borderRadius: 6 }} />
            </Box>
          );
        }
        return null;
      })}
    </Box>
  );
}

function linkify(text: string) {
  const parts = text.split(/(https?:\/\/[^\s]+)/g);
  return parts.map((part, i) =>
    /^https?:\/\//.test(part) ? (
      <MUILink key={i} href={part} target="_blank" rel="noopener noreferrer">{part}</MUILink>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
}

function linkifyInline(text: string) {
  return linkify(text);
}


